module.exports = __webpack_public_path__ + "static/media/wyy.044ee2a4.svg";